jQuery(document).ready(function( $ ) {

	// SLIDER *********************
	$('.home-slider').bxSlider({
	  mode: 'fade',
	  adaptiveHeight: true,
	  touchEnabled: false
	});

	$('.slider-content').bxSlider({
		mode: 'horizontal'
	});

	// MOBILE NAVIGATION TOGGLE **************
	$( ".mobile-nav" ).click(function() {
		$( this ).toggleClass( "open" );
		$( "body" ).toggleClass( "mobile-nav--open" );
		$( ".mobile-menu--wrapper" ).slideToggle();
	});

	$( "table" ).wrap( "<div class='table-scroll'></div>" );


	$( "#menu-mobile-nav .menu-item-has-children > a, #menu-mobile-nav-en .menu-item-has-children > a" ).on("click", function(e){
		e.preventDefault();
		styleReset();
		var subMenu = $(this).parent().children(".menu");
		var menuHeight = subMenu.height();
		if(menuHeight > 300) {
			$("#menu-mobile-nav, #menu-mobile-nav-en").height(menuHeight);
		}

		subMenu.show().animate({
		    left: "100%"
		  }, 300);
	});

	function styleReset() {
		$( "#menu-mobile-nav .menu-item-has-children .menu, #menu-mobile-nav-en .menu-item-has-children .menu" ).each(function() {
			var left = $(this).css("left");

			if(left != "200%") {
				$(this).animate({
					left: "200%"
				}, 300).hide();
			}
			
		});
	}

	var initialPos =  $('.main-menu--container').offset().top;
	var navHeight =  $('.main-menu--container').height();
	// STICKY NAV *******************
	$(window).on('scroll', function(){
		var top = $(window).scrollTop();
	    if (top > initialPos) {
	        $('.main-menu--container').addClass('sticky');
	        $('body').css("paddingTop", navHeight + "px");
	    }
	    else {
	        $('.main-menu--container').removeClass('sticky');
	        $('body').css("paddingTop", "0px");
	    }
	});

	// SCROLL TO HASHTAG NAV *******************
	$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
	    // On-page links
	    if (
	      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	      && 
	      location.hostname == this.hostname
	    ) {
	      // Figure out element to scroll to
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	      // Does a scroll target exist?

	      if (target.length) {
	        // Only prevent default if animation is actually gonna happen
	        var top_padding = 100;
	        event.preventDefault();
	        $('html, body').animate({
	          scrollTop: target.offset().top - top_padding
	        }, 1000);
	      }
	    }

	    if ($(window).width() <= 768) {
		    $('.mobile-nav').removeClass( "open" );
			$( ".mobile-menu--wrapper" ).hide();
		}
	});


	// LEVEL from COURSES PAGES *******************
	$(".accordion-title").on("click", function(){
		removeActiveClass();
		$(this).parent().children('.sub-titles').find('a:first-child').addClass("active");
		$(this).parent().children('.accordion-content').find('.levels div:first-child').addClass("active");
		var levelHeight = $(this).parent().children('.accordion-content').find('.levels .active').height();
		$(this).parent().children('.accordion-content').find('.levels').height(levelHeight);
	});

	function removeActiveClass() {
		$( ".accordion .accordion-item" ).each(function() {
		  $(this).children('.sub-titles').find('a').removeClass("active");
		});

		$( ".accordion-item .accordion-content .levels" ).each(function() {
		  $(this).children('div').removeClass("active");
		});
	}

	$('.sub-titles a').on("click", function(e){
		e.preventDefault();
		removeActiveClass();

		var accordionContent = $(this).parent().next();
		if(accordionContent.parent().hasClass('is-active')) {
			$(this).addClass('active');
			var classNames = $(this).attr('class').split(' ');
			accordionContent.find('.' + classNames[0]).addClass('active');
		} else {
			accordionContent.parent().children('.accordion-title').trigger( "click" );
			removeActiveClass();
			$(this).addClass('active');
			var classNames = $(this).attr('class').split(' ');
			accordionContent.find('.' + classNames[0]).addClass('active');
		}


		var levelHeight = accordionContent.find('.levels .active').height();
		accordionContent.find('.levels').height(levelHeight);
	});

	// GOOGLE MAP avec popup personnalisé *********************
    var map, popup, Popup;
    initMap();

	/** Initializes the map and the custom popup. */
	function initMap() {
		definePopupClass();

		map = new google.maps.Map(document.getElementById('map'), {
			center: {lat: 45.4148382, lng: -75.6949056},
			zoom: 15,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			noClear: true,
			disableDefaultUI: false,
			scrollwheel: false,
			draggable: true,
			zoomControl: false,
			streetViewControl: false,
			panControl: false,
			mapTypeControl: false
		});

		popup = new Popup(
			new google.maps.LatLng(45.4148382, -75.6949056),
			document.getElementById('content')
		);

		popup.setMap(map);
	
	}

	/** Defines the Popup class. */
	function definePopupClass() {

	  Popup = function(position, content) {
	    this.position = position;

	    content.classList.add('popup-bubble-content');

	    var pixelOffset = document.createElement('div');
	    pixelOffset.classList.add('popup-bubble-anchor');
	    pixelOffset.appendChild(content);

	    this.anchor = document.createElement('div');
	    this.anchor.classList.add('popup-tip-anchor');
	    this.anchor.appendChild(pixelOffset);

	    this.stopEventPropagation();
	  };

	  Popup.prototype = Object.create(google.maps.OverlayView.prototype);


	  Popup.prototype.onAdd = function() {
	    this.getPanes().floatPane.appendChild(this.anchor);
	  };

	  Popup.prototype.onRemove = function() {
	    if (this.anchor.parentElement) {
	      this.anchor.parentElement.removeChild(this.anchor);
	    }
	  };


	  Popup.prototype.draw = function() {
	    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

	    var display =
	        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
	        'block' :
	        'none';

	    if (display === 'block') {
	      this.anchor.style.left = divPosition.x + 'px';
	      this.anchor.style.top = divPosition.y + 'px';
	    }
	    if (this.anchor.style.display !== display) {
	      this.anchor.style.display = display;
	    }
	  };

	  /** Stops clicks/drags from bubbling up to the map. */
	  Popup.prototype.stopEventPropagation = function() {
	    var anchor = this.anchor;
	    anchor.style.cursor = 'auto';

	    ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
	     'pointerdown']
	        .forEach(function(event) {
	          anchor.addEventListener(event, function(e) {
	            e.stopPropagation();
	          });
	        });
	  };
	}




	// Functions on RESIZE
	// -----------------------------------------

	$(window).on("resize", function(){
		// SLIDER *********************
		$('.home-slider').bxSlider({
		  mode: 'fade',
		  adaptiveHeight: true
		});

		$('.slider-content').bxSlider({
			mode: 'horizontal'
		});


	});

});